import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  RequestTypes,
  registerItemKeys,
} from '@core/react-query/features/registers/registers/register/items/item'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { registerItemsKeys } from '@core/react-query/features/registers/registers/register/items'
import { siteBoxDocumentsKeys } from '@core/react-query/features/siteBoxDocuments'
import { IRegisterItemAttachment } from '@core/entities/register/RegisterItemAttachment'

export const useRenameRegisterItemAttachment = (
  options?: UseMutationOptions<
    IRegisterItemAttachment,
    RequestErrorType,
    RequestTypes['renameRegisterItemAttachment']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...registerItemKeys.renameRegisterItemAttachment,
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(registerItemsKeys.itemsByRegisterId._def)
      queryClient.invalidateQueries(
        registerItemKeys.byId({
          registerId: variables.registerId,
          registerItemId: variables.registerItemId,
        }),
      )
      if (data?.siteBoxDocument?.id) {
        queryClient.invalidateQueries(
          siteBoxDocumentsKeys.byId({ documentId: data.siteBoxDocument.id })
            .queryKey,
        )
      }
      options?.onSuccess?.(data, variables, context)
    },
  })
}
